export default __webpack_public_path__ + "static/media/large.dd99019a.jpg";